import React from 'react';
import WavyBackground from './WavyBackground';

const Hero = () => {
  const handleDemoClick = (e) => {
    e.preventDefault();
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      const top = contactSection.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const handleExpertiseClick = (e) => {
    e.preventDefault();
    const expertiseSection = document.getElementById('expertise');
    if (expertiseSection) {
      const top = expertiseSection.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const handleKeyDown = (e, handler) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handler(e);
    }
  };

  return (
    <section id="hero" className="hero">
      <WavyBackground>
        <div className="hero-inner">
          <h1 className="hero-title">
            <span className="hero-line-1">Building Digital Futures.</span>{' '}
            <span className="hero-line-2">With AI</span>
          </h1>

          <p className="hero-sub">
            New generation AI studio offering end-to-end solutions to transform your business
          </p>

          <div className="hero-marquee" aria-hidden="true">
            <div className="hero-marquee-track">
              <span>AI is the new electricity and will transform and improve nearly all areas of human lives. AI is the new electricity and will transform and improve nearly all areas of human lives.</span>
              <span>AI is the new electricity and will transform and improve nearly all areas of human lives. AI is the new electricity and will transform and improve nearly all areas of human lives.</span>
              <span>AI is the new electricity and will transform and improve nearly all areas of human lives. AI is the new electricity and will transform and improve nearly all areas of human lives.</span>
            </div>
          </div>

          <div className="hero-actions">
            <button
              className="btn btn-xl primary"
              onClick={handleDemoClick}
              onKeyDown={(e) => handleKeyDown(e, handleDemoClick)}
              aria-label="Jump to contact form"
            >
              Request a Demo
            </button>

            <button
              className="btn btn-xl btn-ghost"
              onClick={handleExpertiseClick}
              onKeyDown={(e) => handleKeyDown(e, handleExpertiseClick)}
              aria-label="Explore our expertise"
            >
              Explore Expertise
            </button>
          </div>
        </div>
      </WavyBackground>
    </section>
  );
};

export default Hero;
